/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import type { AddToCartItem } from "@farmlands/commerce";

import { Product } from "../../products/storage";
import { CartItem } from "../storage/cart.types";

export const mapToCommerceAddToCartItem = (
  item: Product | CartItem,
  quantity?: number
): AddToCartItem => {
  const resolvedQuantity: number =
    quantity ?? ("quantity" in item && typeof item.quantity === "number" ? item.quantity : 1);

  return {
    productId: parseInt(item.productId.toString(), 10),
    masterProductId: item.masterProductId,
    name: item.name,
    sku: item.itemNumber,
    quantity: resolvedQuantity,
    imageUrl: item.imageUrl,
    imageAlt: item.name,
    size: item.sizeDescription ?? item.size ?? "",
    colour: item.colourDescription ?? item.colour ?? "",
    basePriceExcGst: item.basePriceExcGst,
    discountedPriceExcGst: item.discountedPriceExcGst,
    discountedPriceIncGst: item.discountedPriceIncGst,
    editedPriceExcGst: item.editedPriceExcGst,
    lastEditedReasonCode: item.lastEditedReasonCode,
    lastEditedReasonNote: item.lastEditedReasonNote,
  };
};
